import { ajaxController } from "./controller/AjaxController";
import { SuccessfulLoginResponse } from "../types/Auth/SuccessfulLoginResponse";
import { RefreshResponse } from "../types/Auth/RefreshResponse";
import { UserDto } from "../DTOs/User/UserDto";
import { PagedResult } from "../DTOs/Common/PagedResult";
import { UserRoleDto } from "../DTOs/User/UserRoleDto";

type CreateUserRequest = {
  user: UserDto, password: string
}

type UpdateUserPasswordRequest = {
  userId: string, newPassword: string
}

type UpdateSelfPasswordRequest = {
  oldPassword: string, newPassword: string
}

type LoginModel = {
  email: string, password: string
}

type RefreshRequest = {
  refreshToken: string;
};

export class UserAccountAjax {
  private _ajaxController = ajaxController;
  private _accountEndpoint = "/User"

  public getUsers() {
    return ajaxController.get<PagedResult<UserDto>>(
      `${this._accountEndpoint}/list`,
      {}
    );
  }

  public addUser(newUser: UserDto, password: string) {
    return this._ajaxController.post<CreateUserRequest, UserDto>(
      `${this._accountEndpoint}`,
      { user: newUser, password: password}
    );
  }

  public updateUser(updatedUser: UserDto) {
    return this._ajaxController.put<UserDto>(
      `${this._accountEndpoint}`,
      updatedUser
    );
  }

  public updatePassword(userId: string, newPassword: string) {
    return this._ajaxController.put<UpdateUserPasswordRequest>(
      `${this._accountEndpoint}/password`,
      { userId, newPassword }
    );
  }

  public updateOwnPassword(oldPassword: string, newPassword: string) {
    return this._ajaxController.put<UpdateSelfPasswordRequest>(
      `${this._accountEndpoint}/self/password`,
      { oldPassword, newPassword }
    );
  }

  public deleteUser(userId: string) {
    return this._ajaxController.delete(
      `${this._accountEndpoint}/${userId}`
    );
  }

  getRoles() {
    return ajaxController.get<PagedResult<UserRoleDto>>(
      `${this._accountEndpoint}/roles`,
      {}
    );
  }

  public getMyInfo() {
    return ajaxController.get<UserDto>(
      `${this._accountEndpoint}/me`,
      {}
    );
  }

  // auth
  login(username: string, password: string) {
    return ajaxController.post<LoginModel, SuccessfulLoginResponse>(
      `${this._accountEndpoint}/login`,
      {email: username, password}
    );
  }

  refreshToken(refreshToken: string) {
    return this._ajaxController.post<RefreshRequest, RefreshResponse>(
      `${this._accountEndpoint}/refresh`,
      {refreshToken},
      undefined,
      true
    );
  }
}

export const userAccountAjax = new UserAccountAjax();